"use client"

import { FC, useRef, useState} from "react"
import { Provider } from "react-redux"
import { store } from "@/src/store"
import Header from "@/src/components/Header"
import Hero from "@/src/components/Hero"
import PricingOverview from "@/src/components/PricingOverview"
import PricingDetails from "@/src/components/PricingDetails"
import Advantages from "@/src/components/Advantages"
import Stats from "@/src/components/Stats"
import Services from "@/src/components/Services"
import ContactForm from "@/src/components/ContactForm/ContactForm"
import FAQ from "@/src/components/FAQ"
import Footer from "@/src/components/Footer"
import Reviews from "@/src/components/Reviews"
import { ContentProvider } from "@/src/context/ContentContext"

const HomePage: FC = () => {
  const [activeId, setActiveId] = useState("pricing-basic")
  const detailsRef = useRef<HTMLDivElement>(null)

  const handleSelectPlan = (id: string) => {
    setActiveId(id)
    if (detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <Provider store={store}>
      <ContentProvider>
      <div className="bg-black">
        <Header />
        <main>
          <Hero />
          <PricingOverview activeId={activeId} setActiveId={handleSelectPlan} />
          <div ref={detailsRef}>
            <PricingDetails activeId={activeId} />
          </div>
          <Advantages />
          <Stats />
          <Services />
          <Reviews />
          <ContactForm />
          <FAQ />
        </main>
        <Footer />
      </div>
      </ContentProvider>
    </Provider>
  )
}

export default HomePage

